<script>
/**
 * Widget-stat component -- specify the widget title, image, value, subtext and color of subtext.
 */
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    subText: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      default: "/"
    },
    className: {
      type: String,
      default: ""
    },
  },
  methods:{
    handleChangePage(path){
      this.$router.push(path);
    }
  }
};
</script>

<template>
  <div
      @click="handleChangePage(path)"
        class="card mini-stat"
      :class="`${className}`"
      style="cursor: pointer;"
  >
    <div class="card-body">
      <div class="card-icon me-2" >
        <div class="d-flex justify-content-between align-content-start flex-row-reverse">
          <div class="ico-item">
            <img :src="`${image}`" alt="" class="w-100 h-100">
          </div>
          <div class="card-title mb-0 mt-2">
            <h5 class="font-size-16 mt-0 mb-4 text-dark fw-bold">{{title}}</h5>
            <h4 class="fw-bold fs-1 cs-title-start mb-0">
              {{value}}
            </h4>
          </div>
        </div>
      </div>
    </div>


<!--    <div class="card-body d-flex justify-content-between flex-column">-->
<!--      <div class="mb-3 d-flex justify-content-start align-items-center">-->
<!--        <div class="card-icon me-2">-->
<!--          <div class="ico-item d-flex justify-content-center align-items-center">-->
<!--            <i :class="`mdi ${icon} text-primary`"></i>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="card-title mb-0">-->
<!--          <h5 class="font-size-16 mt-0 mb-0 text-white">{{title}}</h5>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="card-content d-flex justify-content-center align-items-center">-->
<!--        <h4 class="fw-bold fs-1 text-white">-->
<!--          {{value}}-->
<!--        </h4>-->
<!--      </div>-->
<!--      <div class="card-content d-flex justify-content-end align-items-center">-->
<!--        <i class="mdi mdi-arrow-right"></i>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>
<style>
.card-icon .ico-item{
  width: 70px;
  height: 70px;
  border-radius: 50px;
  margin-bottom: 20px;
}
</style>
